import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de';

window.flatpickr = flatpickr;
window.flatpickrGerman = German;
